import axios from 'axios';
import { OffersResponse } from '@/types/offerWall';
import { SubmissionRequest } from '@/types/pipedream';
import {
  agentReviewApi,
  calculatorFormApi,
  pipedreaemApi,
  referralFormApi,
  selfServiceApi,
  triPointApi,
} from '../axiosConfig';

import { logEmptyOffersWarning } from '../logger';

export class InternalPipedreamService {
  static async logEmptyOffersWarning(submissionId: string) {
    await logEmptyOffersWarning(submissionId);
  }

  static async createSubmission(data: SubmissionRequest) {
    const response = await pipedreaemApi.post<OffersResponse>(
      'rml-offer-wall',
      data
    );
    return response;
  }

  static async secondRunSubmission(data: SubmissionRequest) {
    const response = await pipedreaemApi.post<OffersResponse>(
      'rml-offer-wall-1l-no-upstart',
      data
    );
    return response;
  }

  static async agentReviewOffers(data: SubmissionRequest) {
    const response = await agentReviewApi.post<OffersResponse>('', data);
    return response;
  }

  static async getUserIpAddress() {
    try {
      const response = await axios.get<{ ip: string }>(
        'https://api.ipify.org/?format=json'
      );
      return response;
    } catch {
      return {
        data: {
          ip: '',
        },
      };
    }
  }

  static async triPointSubmission(data: SubmissionRequest) {
    const response = await triPointApi.post<{ recordId: string }>('', data);
    return response;
  }

  static async selfServiceSubmission(data: SubmissionRequest) {
    const response = await selfServiceApi.post<OffersResponse>('', data);
    return response;
  }

  static async calculatorSubmission(data: SubmissionRequest) {
    const response = await calculatorFormApi.post<OffersResponse>('', data);
    return response;
  }

  static async referralSubmission(data: SubmissionRequest) {
    const response = await referralFormApi.post<OffersResponse>('', data);
    return response;
  }
}
